let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("adJQg")).then(() => parcelRequire('5dxxV'));